import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

const registerAppShellSupport = async () => {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register(
      new URL('./lib/focusflow-sw.js', import.meta.url),
      { type: 'module' }
    );

    const precacheUrls = Array.from(
      document.querySelectorAll('script[src], link[rel="stylesheet"][href], link[rel="icon"][href], link[rel="manifest"][href]')
    )
      .map((element) => {
        const url = element.getAttribute('src') || element.getAttribute('href');
        if (!url) return null;
        return new URL(url, window.location.href).href;
      })
      .filter((value): value is string => Boolean(value));

    precacheUrls.push(new URL('/', window.location.href).href);
    precacheUrls.push(new URL('/index.html', window.location.href).href);

    const postShellAssets = () => {
      registration.active?.postMessage({ type: 'PRECACHE_URLS', urls: precacheUrls });
    };

    if (registration.active) {
      postShellAssets();
    } else {
      navigator.serviceWorker.ready.then(postShellAssets).catch(() => {});
    }
  } catch (error) {
    console.warn('FocusFlow app-shell support could not be registered:', error);
  }
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    void registerAppShellSupport();
  });
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
